import DateInput from '@/common/components/base/input/dateInput/DateInput';
import MobileInput from '@/common/components/base/input/mobileInput/MobileInput';
import RadioGroup from '@/common/components/base/input/radioGroup/RadioGroup';
import TextInput from '@/common/components/base/input/textInput/TextInput';
import { PERSIAN_LATTER_RULE } from '@/common/components/base/input/textInput/textInput.rules';
import { requiredText } from '@/common/utils/rules/publicRules';
import { validateNotFutureDate } from '@/modules/adjusterReportModules/IncidentDetails/utils/incidentDetails.util';
import { css } from 'styled-system/css';
import { Box } from 'styled-system/jsx';
const AddDamagedOtherRealForm = () => {
  return (
    <>
      <RadioGroup
        wrapperClassName={css({ mt: '2rem', mb: '2rem' })}
        className={css({ gap: '2rem' })}
        title="جنسیت (اختیاری)"
        name="gender"
        options={[
          { label: 'آقا', value: 'male' },
          { label: 'خانم', value: 'female' },
        ]}
        renderRadioButton={(Component) => <Box>{Component}</Box>}
      />
      <TextInput
        label="نام"
        name="first_name"
        placeholder="نام را وارد کنید"
        rules={{ required: requiredText, ...PERSIAN_LATTER_RULE }}
      />
      <TextInput
        label="نام ‌خانوادگی"
        name="last_name"
        placeholder="نام ‌خانوادگی را وارد کنید"
        rules={{ required: requiredText, ...PERSIAN_LATTER_RULE }}
      />
      <Box>
        <MobileInput name="phone_number" />
      </Box>
      <DateInput
        buttonText="ثبت"
        name="birthdate"
        modalLabel="تاریخ تولد"
        rules={{
          required: requiredText,
          validate: validateNotFutureDate,
        }}
        label="تاریخ تولد"
      />
      <TextInput
        label="کدملی"
        name="national_code"
        placeholder="کدملی را وارد کنید"
        rules={{ required: requiredText }}
        max={10}
        noCharInput
      />
    </>
  );
};

export default AddDamagedOtherRealForm;
